import React from "react";
import Tabs, { TabsProps, } from "./Tabs";
import { useTabContext, getPanelId, getTabId, } from "./TabContext";

export interface TabListProps extends Omit<TabsProps, "value"> {
  children?: React.ReactNode;
}

// Equivalente ao TabList: é um Tabs que lê o `value`
// atual do TabContext e injeta os ids de acessibilidade (id/aria-controls)
// em cada Tab filho, ligando-o ao TabPanel correspondente.
const TabList = React.forwardRef<HTMLDivElement, TabListProps>((props, ref) => {
  const { children, ...other } = props;
  const context = useTabContext();

  const childrenWithIds = React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) return child;

    const childValue = (child.props as { value?: unknown; }).value;

    // Só liga os ids quando o Tab declara `value` (igual ao MUI lab, que
    // exige value explícito nos filhos do TabList).
    if (childValue === undefined) return child;

    return React.cloneElement(child as React.ReactElement<{ id?: string; "aria-controls"?: string; }>, {
      id: getTabId(context, childValue),
      "aria-controls": getPanelId(context, childValue),
    });
  });

  return (
    <Tabs ref={ref} value={context.value} {...other}>
      {childrenWithIds}
    </Tabs>
  );
});

TabList.displayName = "TabList";

export default TabList;
